import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ChangeIcon = ({ label = 'Change', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="m48.5 101.4 42.2 42.2v-16.2a5 5 0 0 1 5-5h157.8v-42H95.7a5.1 5.1 0 0 1-5-5V59.1z" style="fill:#ff9015"/><path d="M90.7 59.1v16.3a5.1 5.1 0 0 0 5 5h157.8v42H95.7a5 5 0 0 0-5 5v16.2l-42.2-42.2 42.2-42.3m0-10a9.9 9.9 0 0 0-7 3L41.5 94.3a9.8 9.8 0 0 0 0 14.1l42.2 42.2a9.9 9.9 0 0 0 7 3 10.9 10.9 0 0 0 3.9-.8 9.9 9.9 0 0 0 6.1-9.2v-11.2h152.8a10 10 0 0 0 10-10v-42a9.9 9.9 0 0 0-10-10H100.7V59.1a10 10 0 0 0-6.1-9.2 10.9 10.9 0 0 0-3.9-.8z" style="fill:#1d1d1b"/><path d="M46.5 219.6h157.8a5.1 5.1 0 0 1 5 5v16.3l42.2-42.3-42.2-42.2v16.2a5 5 0 0 1-5 5H46.5z" style="fill:#ff9015"/><path d="m209.3 156.4 42.2 42.2-42.2 42.3v-16.3a5.1 5.1 0 0 0-5-5H46.5v-42h157.8a5 5 0 0 0 5-5v-16.2m0-10a10.9 10.9 0 0 0-3.9.8 9.9 9.9 0 0 0-6.1 9.2v11.2H46.5a10 10 0 0 0-10 10v42a9.9 9.9 0 0 0 10 10h152.8v11.3a10 10 0 0 0 6.1 9.2 10.9 10.9 0 0 0 3.9.8 9.9 9.9 0 0 0 7-3l42.2-42.2a9.8 9.8 0 0 0 0-14.1l-42.2-42.2a9.9 9.9 0 0 0-7-3zm31.2-50.9h-43a5 5 0 0 1-5-5 5 5 0 0 1 5-5h43a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm-56.5 0h-9a5 5 0 0 1-5-5 5 5 0 0 1 5-5h9a5 5 0 0 1 5 5 5 5 0 0 1-5 5z" style="fill:#1d1d1b"/><path d="M122 192.5H79a5 5 0 0 1-5-5 5 5 0 0 1 5-5h43a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm-56.5 0h-9a5 5 0 0 1-5-5 5 5 0 0 1 5-5h9a5 5 0 0 1 5 5 5 5 0 0 1-5 5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

ChangeIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ChangeIcon }
